export enum ItemStatus {
  NEW,
  READ,
  DELETED,
}
